import React, { useEffect,useState } from "react";
import {
  FaCreditCard,
  FaMapMarkerAlt,
  FaUniversity,
  FaMoneyCheck,
  FaExclamationTriangle,
  FaInfoCircle,
  FaSave,
   FaEye,
  FaEyeSlash,
} from "react-icons/fa"

const PaymentMethods = ({
  handleSaveEvent,
  onlinePaymentEnabled,
  setOnlinePaymentEnabled,
  payAtVenueEnabled,
  setPayAtVenueEnabled,
  bankTransferEnabled,
  setBankTransferEnabled,
  chequePaymentEnabled,
  setChequePaymentEnabled,
  onlineThankYou,
  setOnlineThankYou,
  venueThankYou,
  setVenueThankYou,
  bankThankYou,
  setBankThankYou,
  chequeThankYou,
  setChequeThankYou,
  bankDetails,
  setBankDetails,
  includeQR,
  setIncludeQR,
  mandatoryTransaction,
  setMandatoryTransaction,
  beneficiaryName,
  setBeneficiaryName,
  chequeAddress,
  setChequeAddress,
  razorpayPublishKey,
  razorpaySecretKey,
  setRazorpayPublishKey,
  setRazorpaySecretKey,
  getValidation
}) => {
  useEffect(() => {
    console.log("PaymentMethods props:", {
      onlinePaymentEnabled,
      payAtVenueEnabled,
      bankTransferEnabled,
      chequePaymentEnabled,
      onlineThankYou,
      venueThankYou,
      bankThankYou,
      chequeThankYou,
      bankDetails,
      includeQR,
      mandatoryTransaction,
      beneficiaryName,
      chequeAddress,
    })
  }, [
    onlinePaymentEnabled,
    payAtVenueEnabled,
    bankTransferEnabled,
    chequePaymentEnabled,
    onlineThankYou,
    venueThankYou,
    bankThankYou,
    chequeThankYou,
    bankDetails,
    includeQR,
    mandatoryTransaction,
    beneficiaryName,
    chequeAddress,
  ])
  const [showPublishKey, setShowPublishKey] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState(false);
  return (
    <div className="container-fluid">
      <div className="row clearfix">
        <div className="col-lg-12">
          <div className="card">
            <div className="body border-0 p-0">
              <div className="row">
                {/* Online Payment */}
                <div className="col-md-12 mb-4">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "48px",
                          height: "48px",
                          backgroundColor: "#f1f5f9",
                          borderRadius: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <FaCreditCard size={20} color="#184778" />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "8px",
                          }}
                        >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={onlinePaymentEnabled === "yes"}
                              onChange={(e) => setOnlinePaymentEnabled(e.target.checked ? "yes" : "no")}
                              style={{ accentColor: "#184778" }}
                            />
                          </div>
                          <label
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#1f2937",
                              margin: 0,
                            }}
                          >
                            Online Payment
                          </label>
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#6b7280",
                            margin: 0,
                            lineHeight: "1.5",
                          }}
                        >
                          Enabling this payment method allows attendees to make online payments conveniently.
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        backgroundColor: "#fef3c7",
                        border: "1px solid #f59e0b",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        marginBottom: "20px",
                        fontSize: "14px",
                        color: "#92400e",
                      }}
                    >
                      <FaExclamationTriangle style={{ flexShrink: 0, marginTop: "2px" }} />
                      <span>
                        USD currency may not be supported by your selected gateway (Razorpay) in this country. Please
                        check your Razorpay settings and ensure that international payments are enabled.
                      </span>
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Thank you message
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        style={{
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          fontSize: "14px",
                          transition: "border-color 0.2s ease",
                          width: "100%",
                        }}
                        placeholder="Modify or add additional details to the thank you messages displayed after payment"
                        value={onlineThankYou}
                        onChange={(e) => setOnlineThankYou(e.target.value)}
                      />
                    </div>
                   <div style={{ marginBottom: "20px", position: "relative" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                          display: "block",
                          textTransform:"none"
                        }}
                      >
                       Razorpay Publishable Key (e.g., rzp_live_xxxxxxxxxx)
                      </label>
                      <input
                        type={showPublishKey ? "text" : "password"}
                        className="form-control"
                        style={{
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          padding: "12px 40px 12px 16px",
                          fontSize: "14px",
                          width: "100%",
                        }}
                        placeholder="Enter your Razorpay publish key"
                        value={razorpayPublishKey}
                        onChange={(e) => setRazorpayPublishKey(e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPublishKey(!showPublishKey)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "38px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          color: "#6b7280",
                        }}
                      >
                        {showPublishKey ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>

                    {/* ✅ Secret Key with Eye Toggle */}
                    <div style={{ marginBottom: "20px", position: "relative" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                          display: "block",
                          textTransform:"none"
                        }}
                      >
                       Razorpay Secret Key (e.g., a long string like abcdefghijklmnopqrstuvwxyz123456)
                      </label>
                      <input
                        type={showSecretKey ? "text" : "password"}
                        className="form-control"
                        style={{
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          padding: "12px 40px 12px 16px",
                          fontSize: "14px",
                          width: "100%",
                        }}
                        placeholder="Enter your Razorpay secret key"
                        value={razorpaySecretKey}
                        onChange={(e) => setRazorpaySecretKey(e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={() => setShowSecretKey(!showSecretKey)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "38px",
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          color: "#6b7280",
                        }}
                      >
                        {showSecretKey ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Pay at Venue */}
                <div className="col-md-12 mb-4">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "48px",
                          height: "48px",
                          backgroundColor: "#f1f5f9",
                          borderRadius: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <FaMapMarkerAlt size={20} color="#184778" />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "8px",
                          }}
                        >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={payAtVenueEnabled === "yes"}
                              onChange={(e) => setPayAtVenueEnabled(e.target.checked ? "yes" : "no")}
                              style={{ accentColor: "#184778" }}
                            />
                          </div>
                          <label
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#1f2937",
                              margin: 0,
                            }}
                          >
                            Pay at Venue
                          </label>
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#6b7280",
                            margin: 0,
                            lineHeight: "1.5",
                          }}
                        >
                          Enabling this payment method allows attendees to pay at the event venue.
                        </p>
                      </div>
                    </div>

                    <div style={{ marginBottom: "20px" }}>
                      <label
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#374151",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Thank you message
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        style={{
                          border: "1px solid #d1d5db",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          fontSize: "14px",
                          transition: "border-color 0.2s ease",
                          width: "100%",
                        }}
                        placeholder="Modify or add additional details to the thank you messages displayed after registration"
                        value={venueThankYou}
                        onChange={(e) => setVenueThankYou(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* Bank Transfer */}
                <div className="col-md-12 mb-4">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "48px",
                          height: "48px",
                          backgroundColor: "#f1f5f9",
                          borderRadius: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <FaUniversity size={20} color="#184778" />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "8px",
                          }}
                        >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={bankTransferEnabled === "yes"}
                              onChange={(e) => setBankTransferEnabled(e.target.checked ? "yes" : "no")}
                              style={{ accentColor: "#184778" }}
                            />
                          </div>
                          <label
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#1f2937",
                              margin: 0,
                            }}
                          >
                            Bank Transfer
                          </label>
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#6b7280",
                            margin: 0,
                            lineHeight: "1.5",
                          }}
                        >
                          Enabling this payment method allows attendees to deposit payment into the bank account
                          provided here.
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div style={{ marginBottom: "20px" }}>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Beneficiary Bank Details
                          </label>
                          <textarea
                            className="form-control"
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              padding: "12px 16px",
                              fontSize: "14px",
                              transition: "border-color 0.2s ease",
                              width: "100%",
                              resize: "vertical",
                            }}
                            placeholder="Add your bank details here..."
                            value={bankDetails}
                            onChange={(e) => setBankDetails(e.target.value)}
                            rows={4}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ marginBottom: "16px" }}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={includeQR}
                              onChange={(e) => setIncludeQR(e.target.checked)}
                              style={{ accentColor: "#184778" }}
                            />
                            <label
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#374151",
                                marginLeft: "8px",
                              }}
                            >
                              Include QR Code
                            </label>
                          </div>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#6b7280",
                              margin: "4px 0 0 24px",
                              lineHeight: "1.4",
                            }}
                          >
                            Display your bank account QR code for easy payment
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ marginBottom: "16px" }}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={mandatoryTransaction}
                              onChange={(e) => setMandatoryTransaction(e.target.checked)}
                              style={{ accentColor: "#184778" }}
                            />
                            <label
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#374151",
                                marginLeft: "8px",
                              }}
                            >
                              Make it mandatory to provide transaction details
                            </label>
                          </div>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#6b7280",
                              margin: "4px 0 0 24px",
                              lineHeight: "1.4",
                            }}
                          >
                            If enabled buyers must submit the transaction ID after the bank transfer to complete the
                            registration process
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                        backgroundColor: "#dbeafe",
                        border: "1px solid #3b82f6",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        marginBottom: "20px",
                        fontSize: "14px",
                        color: "#1e40af",
                      }}
                    >
                      <FaInfoCircle style={{ flexShrink: 0, marginTop: "2px" }} />
                      <span>
                        When payment is received, check the transaction ID to ensure it matches. Then, update the order
                        by adding the payment. Note that the order status will remain 'pending' until this step is
                        completed.
                      </span>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ marginBottom: "20px" }}>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Thank you message
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              padding: "12px 16px",
                              fontSize: "14px",
                              transition: "border-color 0.2s ease",
                              width: "100%",
                            }}
                            placeholder="Modify or add additional details to the thank you messages displayed after registration"
                            value={bankThankYou}
                            onChange={(e) => setBankThankYou(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ marginBottom: "20px" }}>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Beneficiary Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              padding: "12px 16px",
                              fontSize: "14px",
                              transition: "border-color 0.2s ease",
                              width: "100%",
                            }}
                            placeholder="Enter beneficiary name"
                            value={beneficiaryName}
                            onChange={(e) => setBeneficiaryName(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Cheque Payment */}
                <div className="col-md-12 mb-4">
                  <div
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      padding: "24px",
                      marginBottom: "16px",
                      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "16px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "48px",
                          height: "48px",
                          backgroundColor: "#f1f5f9",
                          borderRadius: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <FaMoneyCheck size={20} color="#184778" />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            marginBottom: "8px",
                          }}
                        >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={chequePaymentEnabled === "yes"}
                              onChange={(e) => setChequePaymentEnabled(e.target.checked ? "yes" : "no")}
                              style={{ accentColor: "#184778" }}
                            />
                          </div>
                          <label
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: "#1f2937",
                              margin: 0,
                            }}
                          >
                            Cheque Payment
                          </label>
                        </div>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#6b7280",
                            margin: 0,
                            lineHeight: "1.5",
                          }}
                        >
                          Enabling this payment method allows attendees to pay via cheque.
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div style={{ marginBottom: "20px" }}>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Cheque Address
                          </label>
                          <textarea
                            className="form-control"
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              padding: "12px 16px",
                              fontSize: "14px",
                              transition: "border-color 0.2s ease",
                              width: "100%",
                              resize: "vertical",
                            }}
                            placeholder="Add the address where cheques should be sent..."
                            value={chequeAddress}
                            onChange={(e) => setChequeAddress(e.target.value)}
                            rows={4}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div style={{ marginBottom: "20px" }}>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Thank you message
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            style={{
                              border: "1px solid #d1d5db",
                              borderRadius: "8px",
                              padding: "12px 16px",
                              fontSize: "14px",
                              transition: "border-color 0.2s ease",
                              width: "100%",
                            }}
                            placeholder="Modify or add additional details to the thank you messages displayed after registration"
                            value={chequeThankYou}
                            onChange={(e) => setChequeThankYou(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Save Button */}
                <div className="col-md-12">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      paddingTop: "24px",
                      borderTop: "1px solid #e5e7eb",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: "#184778",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "12px 24px",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                      }}
                      onClick={handleSaveEvent}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#0f3a5f"
                        e.currentTarget.style.transform = "translateY(-1px)"
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#184778"
                        e.currentTarget.style.transform = "translateY(0)"
                      }}
                    >
                      <FaSave style={{ fontSize: "14px" }} />
                      Save Payment Settings
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentMethods
